import { Component } from '@angular/core';
import {TranslateService} from "@ngx-translate/core";
import {UserService} from "./core/services/user.service";
import { FreshchatService } from './core/services/fresh-chat.service';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent {
  title = 'bnpl';
  isAuthenticated: boolean;
  constructor(
      public translate: TranslateService,
      private userService: UserService,
      private freshchatService: FreshchatService
  ) {
    translate.addLangs(['en', 'si', 'ta']);
    translate.setDefaultLang('en');
  }

  ngOnInit() {
    this.userService.populate();
    this.freshchatService.initiateCall();
  }

  switchLang(lang: string) {
    this.translate.use(lang);
  }
}
